var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2578 23.5001C14.5384 23.5017 15.8067 23.2502 16.9899 22.7601C18.173 22.27 19.2476 21.551 20.152 20.6443C21.0587 19.7399 21.7777 18.6653 22.2678 17.4822C22.7579 16.299 23.0094 15.0307 23.0078 13.7501C23.0094 12.4695 22.7579 11.2012 22.2678 10.0181C21.7777 8.83493 21.0587 7.7603 20.152 6.8559C19.2476 5.94923 18.173 5.2302 16.9899 4.74011C15.8067 4.25003 14.5384 3.99855 13.2578 4.00013C11.9772 3.99855 10.7089 4.25003 9.52575 4.74011C8.34262 5.2302 7.26799 5.94923 6.36359 6.8559C5.45692 7.7603 4.73789 8.83493 4.2478 10.0181C3.75772 11.2012 3.50624 12.4695 3.50782 13.7501C3.50624 15.0307 3.75772 16.299 4.2478 17.4822C4.73789 18.6653 5.45692 19.7399 6.36359 20.6443C7.26799 21.551 8.34262 22.27 9.52575 22.7601C10.7089 23.2502 11.9772 23.5017 13.2578 23.5001Z",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2578 7.41272C13.581 7.41272 13.891 7.54112 14.1196 7.76968C14.3482 7.99824 14.4766 8.30824 14.4766 8.63147C14.4766 8.9547 14.3482 9.26469 14.1196 9.49325C13.891 9.72181 13.581 9.85022 13.2578 9.85022C12.9346 9.85022 12.6246 9.72181 12.396 9.49325C12.1675 9.26469 12.0391 8.9547 12.0391 8.63147C12.0391 8.30824 12.1675 7.99824 12.396 7.76968C12.6246 7.54112 12.9346 7.41272 13.2578 7.41272Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5012 18.6252V11.8002H12.5262M11.7949 18.6252H15.2074",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.7fe8fd6e33c4d960b1b54a9d95db2266.svg";
export { ForwardRef as ReactComponent };